// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"snN2a","content":"Y5cKj","image":"_1nT2q","status":"NkLdt","status-message1":"vbJ1Z","status-message2":"xRBfb","button":"_28fMG"};